// The ≤767 bell: the design's 20px "Notification active" asset, inlined so
// the glyph follows currentColor and the badge's disc follows the theme.
// The vuesax linear bell sits at ~84% inside the box (the same outline
// bell.svg draws at full size for the desktop mask) so the 7px dot fits
// inside the icon box; the background-secondary disc under the dot masks
// the outline it overlaps.
export default function BellIcon({ unread }: { unread: boolean }) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.43522 8.2499C3.43522 5.63756 5.55765 3.51513 8.16999 3.51513C10.7753 3.51513 12.9048 5.64458 12.9048 8.2499V10.2771C12.9048 10.4278 12.9389 10.6484 13.0035 10.8841C13.0674 11.117 13.1499 11.3239 13.225 11.4553L14.0293 12.7912C14.6644 13.8498 14.1567 15.2289 12.9865 15.6163C9.85528 16.6623 6.47684 16.6622 3.34567 15.616L3.34372 15.6154C2.75281 15.4154 2.30967 15.0019 2.11153 14.4668C1.91317 13.9311 1.98065 13.3281 2.30404 12.7906L3.1096 11.4527C3.10978 11.4524 3.10996 11.4521 3.11013 11.4518C3.18695 11.3226 3.27109 11.1164 3.33602 10.8825C3.40115 10.6479 3.43522 10.4276 3.43522 10.2771V8.2499ZM8.16999 4.5673C6.13875 4.5673 4.48739 6.21866 4.48739 8.2499V10.2771C4.48739 10.5544 4.43027 10.8743 4.34985 11.164C4.26938 11.4538 4.15385 11.7558 4.01336 11.9915L4.01218 11.9934L3.20559 13.3331C3.20557 13.3331 3.20562 13.333 3.20559 13.3331C3.03104 13.6232 3.02129 13.8936 3.09823 14.1014C3.17534 14.3097 3.3597 14.5097 3.6801 14.6184C6.59485 15.592 9.73917 15.5919 12.6539 14.6181L12.6555 14.6176C13.1821 14.4435 13.4175 13.8171 13.1273 13.3329C13.1272 13.3327 13.1273 13.333 13.1273 13.3329L12.3157 11.985C12.181 11.7514 12.0681 11.4516 11.9888 11.1624C11.9097 10.8738 11.8526 10.5543 11.8526 10.2771V8.2499C11.8526 6.22567 10.1942 4.5673 8.16999 4.5673Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.38249 4.05268C6.66268 3.33771 7.35831 2.83473 8.16999 2.83473C8.98166 2.83473 9.67729 3.33771 9.95748 4.05268C10.0306 4.23932 9.99134 4.4513 9.85619 4.59934C9.72103 4.74738 9.51349 4.80575 9.32098 4.74986C9.1264 4.69337 8.93001 4.65074 8.73097 4.62661L8.72902 4.62637C8.12268 4.55058 7.54977 4.59557 7.01916 4.74981C6.82664 4.80578 6.61905 4.74745 6.48385 4.59941C6.34864 4.45137 6.30934 4.23935 6.38249 4.05268Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.59169 15.3696C6.59169 15.7992 6.77042 16.2002 7.05487 16.4847C7.33933 16.7691 7.74029 16.9478 8.16994 16.9478C9.03678 16.9478 9.7482 16.2364 9.7482 15.3696H10.8004C10.8004 16.8175 9.61788 18 8.16994 18C7.44922 18 6.78398 17.7018 6.31087 17.2286C5.83777 16.7555 5.53952 16.0903 5.53952 15.3696H6.59169Z"
        fill="currentColor"
      />
      {unread && (
        <>
          <path
            d="M18.2567 6.20868C18.2567 8.53307 16.3725 10.4174 14.0481 10.4174C11.7237 10.4174 9.83939 8.53307 9.83939 6.20868C9.83939 3.88429 11.7237 2 14.0481 2C16.3725 2 18.2567 3.88429 18.2567 6.20868Z"
            className="fill-background-secondary"
          />
          <circle cx={13.8134} cy={6.5} r={3.5} className="fill-red-default" />
        </>
      )}
    </svg>
  );
}
